import React from 'react';

import '../../utils/styles/Tips.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function Tips() {
    return (
        <div className="container">
            <p className="title-3">Tips</p>
            <div className="content">
                <p className="paragraph">
                    Bienvenue dans la section "Tips" ! Ici, tu retrouveras
                    toutes les informations essentielles sur la vie étudiante et
                    le campus : services disponibles, lieux importants,
                    ressources utiles et bien plus encore. Cette section est ton
                    guide pratique pour t'aider à t'orienter et profiter au
                    mieux de ton expérience universitaire. Explore et découvre
                    tout ce que le campus a à t'offrir !
                </p>
            </div>

            <div className="content">
                <p className="title">Bien-être</p>
                <p className="paragraph">
                    Besoin d'un coup de pouce pour ton bien-être ? L'UNamur met
                    à ta disposition des aides financières et sociales, un
                    service médico-social, et un accompagnement pour les
                    étudiants à besoins spécifiques.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/campus/bien-etre"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Vie sur le campus</p>
                <p className="paragraph">
                    À la recherche d'un logement étudiant ou d'un endroit pour
                    étudier ? L'UNamur te propose des bibliothèques et diverses
                    solutions de logement.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/campus/vivre"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Coûts de la vie étudiante</p>
                <p className="paragraph">
                    Envie d'anticiper ton budget étudiant ? Découvre un aperçu
                    des dépenses types et des astuces pour gérer ton budget.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/campus/cout-etudes"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Louer une salle</p>
                <p className="paragraph">
                    Besoin d'un espace pour un projet ou un événement ? L'UNamur
                    te propose différentes salles à la location.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/campus/en-pratique/louer-une-salle"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Consigne à bagages</p>
                <p className="paragraph">
                    Besoin de déposer ta valise avant de prendre ton train ? Une
                    consigne est à ta disposition tous les vendredis dès 7h30
                    près de l'accueil de l'Université (61 rue de Bruxelles).
                    Pratique pour voyager léger !
                </p>
            </div>

            <div className="content">
                <p className="title">Inscription</p>
                <p className="paragraph">
                    Tu veux rejoindre l'UNamur ? Toutes les informations sur les
                    démarches d'inscription sont disponibles ici.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/inscription"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Les accès au campus</p>
                <p className="paragraph">
                    Bus, train, vélo… Quel est le meilleur moyen d'accéder au
                    campus ? Trouve toutes les infos pour venir facilement ici.
                </p>
                <div className="link-tips">
                    <a className="button" href="https://www.unamur.be/fr/acces">
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Cellule Phare</p>
                <p className="paragraph">
                    Besoin d'écoute ou de soutien face au harcèlement ? La
                    Cellule Phare est là pour t'aider.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/institution/genre/phare"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">Les lieux d'expression</p>
                <p className="paragraph">
                    Envie de t'exprimer et de partager ta créativité ? L'UNamur
                    met à disposition plusieurs espaces dédiés aux arts et à
                    l'expression étudiante. Découvre où laisser libre cours à
                    ton talent !
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/campus/culture"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>

            <div className="content">
                <p className="title">
                    Cellule interfacultaire d'appui pédagogique
                </p>
                <p className="paragraph">
                    Besoin d'un accompagnement pour ta réussite académique ? Le
                    CIAP est là pour t'aider. Découvre leurs services ici.
                </p>
                <div className="link-tips">
                    <a
                        className="button"
                        href="https://www.unamur.be/fr/fasef/services/ciap"
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Tips;
